import styled from 'styled-components'

export const ElementContainer = styled.div`
  padding: 0rem 1rem;
  margin: 2rem 0;

  ${
    '' /* @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
		padding: 0;
	} */
  }

  &:first-child {
    margin-top: 0;
  }
`
